export const missionShowCardClass =
  'mb-4 rounded-3xl border border-contour'

export const missionShowCardBodyClass = 'flex flex-col gap-4 p-5'
